import React from 'react';
import TimeFormat from '../helpers/TimeFormat';

const OPTIONS = (() => {
  const times = [
    { value: 'sunrise', text: 'Sunrise' },
    { value: 'sunset', text: 'Sunset' }
  ];

  for (let h = 0; h < 24; ++h) {
    let hour = h < 10 ? '0' + h : h;
    times.push({ value: hour + ':00', text: TimeFormat.format_time(h + ':00') });
    times.push({ value: hour + ':30', text: TimeFormat.format_time(h + ':30') });
  }

  return times;
})();

export default function HourSelect(props) {
  return (
    <select
      data-cy="hour-select"
      aria-label={props.label}
      value={props.value}
      onChange={e => props.onChange(e.target.value)}
    >
      {OPTIONS.map(t => (
        <option data-cy="hour-select-option" key={t.value} value={t.value}>
          {t.text}
        </option>
      ))}
    </select>
  );
}
